// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"3ed7af36","215":"c43e9c04","247":"ee5d0540","291":"ea7ecbf5","355":"6366ddda","430":"0e990679","481":"56156893","530":"a12f6426","679":"13d699e8","699":"d6af4ac6","715":"e9ada904","777":"0872748b","958":"7ba08615"}[chunkId] + ".chunk.js";
};